const MYSQL = 1
const MSSQL = 2
const REAL_TIME_SOCKET = 3
const SHOW_HISTORY_USER_DATA = 4
const SHOW_HISTORY_QUEUE_DATA = 5
const ELASTICSEARCH = 6

export default {
    MYSQL,
    MSSQL,
    REAL_TIME_SOCKET,
    SHOW_HISTORY_USER_DATA,
    SHOW_HISTORY_QUEUE_DATA,
    ELASTICSEARCH
}
